import { memo } from 'react';

import { SvgIcon } from '@material-ui/core';

import { SvgIconProps } from './SvgIcon.types';

export const DocumentTextIcon = memo(({ className }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="26"
    height="37"
    viewBox="0 0 26 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fill: 'none' }}
  >
    <path
      d="M17.2776 36H3.19556V3.69238H25V26.5306L17.2776 36Z"
      fill="#F0CBA7"
      stroke="#F0CBA7"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.082 33.3077V23.8382H22.8044"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.082 33.3077H1V1H22.8044V23.8382L15.082 33.3077Z"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8076 7.6842H5.99683"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8076 13.2545H5.99683"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8076 18.8248H5.99683"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.9937 24.3951H5.99683"
      stroke="#EA7200"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
